import { render } from "./VueGallery.vue?vue&type=template&id=1d987810"
import script from "./VueGallery.vue?vue&type=script&lang=js"
export * from "./VueGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__